import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  constructor(private router: Router) {}
  personName: string;
  loading = false;
  ngOnInit() {}

  clearCache() {
    this.loading = true
    localStorage.clear();
    setTimeout(()=>{
      this.loading = false;
      this.personName = '';
      this.router.navigateByUrl('/login');
    }, 2000)
   
  }
}
